export const USER_LOADING = '@USERS_USER_LOADING';
export const USER_LOADED = '@USERS_USER_LOADED';

export const GET_USERS = '@USERS_GET_USERS';
export const GET_USER = '@USERS_GET_USER';
export const REMOVE_USER = '@USERS_DELETE_USER';
export const UPDATE_USER = '@USERS_UPDATE_USER';
export const CREATE_USER = '@USERS_CREATE_USER';


export const GET_STAFF_MEMBERS = '@USERS_GET_STAFF_MEMBERS';
export const GET_STAFF_MEMBER = '@USERS_GET_STAFF_MEMBER';
export const REMOVE_STAFF_MEMBER = '@USERS_REMOVE_STAFF_MEMBER';
export const UPDATE_STAFF_MEMBER = '@USERS_UPDATE_STAFF_MEMBER';
export const CREATE_STAFF_MEMBER = '@USERS_CREATE_STAFF_MEMBER';

export const GET_USERS_WALLET = '@USERS_GET_USERS_WALLET';
export const GET_DASHBOARD_OVERVIEW = '@USERS_GET_DASHBOARD_OVERVIEW';